export const CALL_TYPE_OPTIONS = [
	{ label: 'Inbound', value: 'inbound' },
	{ label: 'Outbound', value: 'outbound' },
];
